import { z } from 'zod';
// ============================================================
// User Schemas
// ============================================================
export const UserRoleSchema = z.enum(['USER', 'ADMIN']);
export const PremiumPlanSchema = z.enum(['FREE', 'PREMIUM']);
export const UserSchema = z.object({
    id: z.string().cuid2(),
    email: z.string().email().max(255),
    emailVerified: z.date().nullable(),
    name: z.string().max(255).nullable(),
    image: z.string().url().max(500).nullable(),
    role: UserRoleSchema.default('USER'),
    premiumPlan: PremiumPlanSchema.default('FREE'),
    aiCredits: z.number().int().min(0).default(2),
    createdAt: z.date(),
    updatedAt: z.date(),
});
// ============================================================
// Auth Schemas
// ============================================================
export const SignupRequestSchema = z.object({
    email: z.string().email('올바른 이메일을 입력하세요'),
    password: z
        .string()
        .min(8, '비밀번호는 최소 8자 이상이어야 합니다')
        .max(100, '비밀번호는 100자를 초과할 수 없습니다')
        .regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/, '비밀번호는 대소문자와 숫자를 포함해야 합니다'),
    name: z.string().min(1, '이름을 입력하세요').max(255),
});
export const LoginRequestSchema = z.object({
    email: z.string().email('올바른 이메일을 입력하세요'),
    password: z.string().min(1, '비밀번호를 입력하세요'),
});
export const UpdateProfileRequestSchema = z.object({
    name: z.string().min(1).max(255).optional(),
    image: z.string().url().max(500).optional(),
});
export const UserResponseSchema = UserSchema.pick({
    id: true,
    email: true,
    name: true,
    image: true,
    role: true,
    premiumPlan: true,
    aiCredits: true,
    createdAt: true,
});
// ============================================================
// Validation Helpers
// ============================================================
export const validateEmail = (email) => {
    return LoginRequestSchema.pick({ email: true }).safeParse({ email }).success;
};
export const validatePassword = (password) => {
    return SignupRequestSchema.pick({ password: true }).safeParse({ password }).success;
};
//# sourceMappingURL=user.js.map